module.exports = __webpack_public_path__ + "puxiimg1.png?a1df78f6ea63fd7b4c6c493e2f8a602b";